// components
import Logo from '../../components/Logo';

/* ============================================================================
   Rodape do site publico (layout `main`) - visual novo (shadcn + Tailwind).

   Substitui `Grid`/`Divider`/`Container`/`Typography`/`Stack` do MUI.

   O QUE SAIU, e por que (nao e simplificacao gratuita - era conteudo falso):

   1. As tres colunas de links (`LINKS`) apontavam para /about-us, /contact-us,
      /faqs e para "#". NENHUMA dessas paginas existe em src/pages (conferido:
      about-us, contact-us, faqs, pricing, payment, coming-soon e components nao
      existem), e o roteador manda tudo que nao casa para o 404. Eram sete links
      quebrados no rodape.

   2. O texto institucional, o endereco "Los Angeles, 359 Hidden Valley Road", o
      e-mail support@minimals.cc e os botoes de rede social (`SocialsButton`, que
      aponta para as redes do template) eram do Minimal UI Kit, nao do Grupo GPS.
      Rodape de produto do cliente anunciando fornecedor de template e defeito de
      conteudo.

   3. O copyright era "© 2021", fixo no codigo. Agora sai do ano corrente.

   Sobrou o que e verdade: marca e copyright. Quando existir conteudo publico de
   verdade (contato, termos), ele entra aqui.
   ============================================================================ */

export default function MainFooter() {
  return (
    <footer className="relative border-t border-line bg-surface-2">
      <div className="mx-auto flex w-full max-w-[1560px] flex-col items-center gap-3 px-4 py-8 text-center md:flex-row md:justify-between md:text-left lg:px-6">
        <Logo sx={{ width: 56, height: 56 }} />

        <p className="text-[12px] text-muted-foreground">
          © {new Date().getFullYear()} Grupo GPS · GPShub. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
